<template>
	<div>
		<buyJd :crtNum='1'></buyJd>
		<!-- 中心区域 -->
		<div class="carCont">
			<!-- 标题行 -->
			<ul class="carTit">
				<!-- 左 -->
				<li class="carTit-lftBox d-cw d-aic d-jcc boxNoYs">
					<!-- 商品数目 -->
					<p>
						全部商品 {{shopList && shopList.length?shopList.length:0}}
					</p>
					<!-- 红线 -->
					<p></p>
				</li>
				<!-- 右 -->
				<li class="carTit-rgtBox d-rn d-aic d-jce boxNoYs">
					<p>已选商品（不含运费）</p>
					<p>{{allSelShopPrice}}</p>
					<p class="showHand" @click="handleJoinSubmit">结算</p>
				</li>
			</ul>
			<!-- 提示行 -->
			<ul class="conTipsBox d-rn d-aic d-jcb">
				<!--左===  -->
				<li class="conTipsBox-lftBox d-rn d-aic d-jcs">
					<p class=" d-rn d-aic d-jcs showHand noSelectBox" @click="handleSelectAllShop">
						<img src="../../assets/img/comm/selectedAll.png" v-show="allSelectState">
						<i v-show="!allSelectState"></i>
						<span>全选</span>
					</p>
					<p>商品信息</p>
				</li>
				<!-- 右=== -->
				<li class="conTipsBox-rgtBox d-rn d-aic d-jce">
					<p v-for="(item,index) in 4" :key='index'>{{!index?'单价':index==1?'数量':index==2?'金额':'操作'}}</p>
				</li>
			</ul>
			
			<!-- 商品显示 -->
			<div class="shopArr" v-show="shopList && shopList.length?true:false">
				<ul v-for="(item,index) in shopList" :key='index'
				:class="['shopArr-itemUlBox','d-rn','d-ais','d-jcs']">
					<!-- 选中样式 -->
					<li class="shopArr-itemSelBox d-rn d-ais d-jcc noSelectBox">
						<p class="showHand" @click="handleSelItemShop(index)">
							<!-- 选中 -->
							<img v-show="selShopArr.indexOf(index)>=0?true:false" src="../../assets/img/comm/icon_selAll.png" >
							<!-- 取消 -->
							<img v-show="selShopArr.indexOf(index)>=0?false:true" src="../../assets/img/comm/icon_shopCarNosel.png" >
						</p>
					</li>
					
					<!-- 商品图片 -->
					<li class="shopArr-itemImg">
						<img :src="item.goodsImg" >
					</li>
					
					<!-- 商品名称 -->
					<li class="shopArr-itemName txt-cut" style="-webkit-line-clamp: 3 !important;">
						{{item.goodsTitle}}
					</li>
					
					<!-- 商品规格 -->
					<div :class="['shopArr-itemSpecs',selShopNum===index?'borXf':'',]"
					@mouseenter="handleCarJoinItemShop(index)" @mouseleave="handleGoOutBox">
						<!-- 规格展示 -->
						<div class="shopArr-itemSpecs-listBox">
							<ul v-for="(itt,ixx) in item.newGgList" :key='ixx'
							:class="[!ixx?'marboxTop10':'marboxTop10','shopArr-itemSpecs-ittTxt','one-txt-cut']">
							{{itt.name}}：{{itt.val}}
							</ul>
						</div>
						<!-- 修改按钮 -->
						<ul class="shopArr-itemSpecs-editBtn showHand"
						 @click.stop="throttle(handleSelEditState,1500,item,index)"
						 v-show="selShopNum===index?true:false">
							修改
						</ul>
						
						
						<!-- 编辑显示 -->
						<div class="shopArr-itemSpecs-editBox" v-if="selEditIndex !=null && selEditIndex==index" @click.stop=""
						>
							<!-- 三角 -->
							<p class="shopArr-itemSpecs-editBox-sanYi"></p>
							<p class="shopArr-itemSpecs-editBox-sanEr"></p>
							<p class="shopArr-itemSpecs-editBox-sanSab"></p>
							
							<!-- 白色框 -->
							<ul class="shopArr-itemSpecs-editBox-selGgBox">
								<!-- 一级规格 -->
								<li class="shopArr-itemSpecs-editBox-itemLiBox d-rn d-aic d-jcs">
									<!-- 左 -->
									<p class="shopArr-itemSpecs-editBox-itemlftBox one-txt-cut">
										{{editOneGgName}}
									</p>
									<!-- 右选项 -->
									<p class="shopArr-itemSpecs-editBox-itemRgtBox d-rw d-aic d-jcs">
										<span v-for="(ittm,iddx) in selEditShopOneGg" :key='iddx' @click="throttle(handleSelEditShopGg,1500,true,iddx)"
										:class="[iddx==selArrGgInfo[0]?'selGGCla':'noselGGCla','showHand']">
											{{ittm.goodsAttrTitle}}
										</span>
									</p>
								</li>
								<!-- 二级规格 -->
								<li class="shopArr-itemSpecs-editBox-itemLiBox d-rn d-aic d-jcs">
									<!-- 左 -->
									<p class="shopArr-itemSpecs-editBox-itemlftBox one-txt-cut">
										{{editTwoGgName}}
									</p>
									<!-- 右选项 -->
									<p class="shopArr-itemSpecs-editBox-itemRgtBox d-rw d-aic d-jcs">
										<span v-for="(ittm,iddx) in selEditShopTwoGg" :key='iddx' @click="handleSelEditShopGg(false,iddx)"
										:class="[iddx==selArrGgInfo[1]?'selGGCla':'noselGGCla','showHand']">
											{{ittm.goodsAttrTitle}}
										</span>
									</p>
								</li>
								<!-- 附件 -->
								<li class="shopArr-itemSpecs-editBox-itemLiBox d-rn d-aic d-jcs">
									<!-- 标题 -->
									<p class="shopArr-itemSpecs-editBox-itemlftBox">
										上传附件
									</p>
									<!-- 图片数据 -->
									<p class="shopArr-itemSpecs-editBox-itemUpImg d-rn d-aic d-jcb">
										<span class="shopArr-itemSpecs-editBox-itemImgBox d-rn d-aic d-jcs"
										v-for="(itte,ixxe) in upFileArr" :key='ixxe'>
											<!-- 1文件2图片 -->
											<i v-for="(iett,iexx) in itte" :key='iexx'>
												<img :src="iett.upInfo&& !iexx?require('../../assets/img/comm/icon_UpFileImg.png'):
												 iett.upInfo&& iexx==1?iett.upInfo:!iexx&& !iett.upInfo?
												 require('../../assets/img/comm/icon_upFile.png'):require('../../assets/img/comm/icon_upImg.png')" >
												
												
												
												
												<el-upload style="position: absolute;width: 100%;height: 100%;background-color: red;
												top: 0;left: 0;opacity: 0;"
													:action="requestUrl" :show-file-list="false"
												:on-error="handleUpFileError" :on-success="handleAvatarSuccess">
												  <i  class="el-icon-plus avatar-uploader-icon" style="position: absolute;width: 100%;height: 100%;background-color: red;
												top: 0;left: 0;" 
												@click='handleSelImgInx(ixxe,iexx)'></i>
												</el-upload>
												<!-- <input class="showHand" type="file" :name="ixxe+'_'+iexx" v-if="!iexx"
													@change="handleUploadImg($event,ixxe,iexx)"
													accept="image/jpeg,image/png,image/gif,application/pdf" />
												<input class="showHand" @change="handleUploadImg($event,index,iexx)" type="file"
													:name="ixxe+'_'+iexx" v-else accept="image/*" /> -->
											</i>
										</span>
									</p>
								</li>
								
								<!-- 提示 -->
								<li class="shopArr-itemSpecs-editBox-itemTipsBox">
									<!-- 注：若没有源文件，请联系客服 -->
									注：{{goodsExplain}}
								</li>
								<!-- 按钮 -->
								<li class="shopArr-itemSpecs-editBox-itemBtnBox d-rn d-aic d-jcs">
									<p class="showHand" @click="handleAgainShopGg(item,index)">确定</p>
									<p class="showHand" @click="selEditIndex=null">取消</p>
								</li>
							</ul>
						</div>
					</div>
					
					<!-- 价格 -->
					<li class="shopArr-itemPrice one-txt-cut">
						￥{{item.traderGoodsMoney?item.traderGoodsMoney.toFixed(2):''}}
					</li>
					<!-- 数量 -->
					<li class="shopArr-itemNumber d-rn d-aic d-jcs">
						<img class="showHand" src="../../assets/img/comm/icon_lftJian.png" @click="handleCalaNum(false,index,item)">
						<p class="one-txt-cut">{{item.cartNum}}</p>
						<img class="showHand" src="../../assets/img/comm/icon_rgtJia.png" @click="handleCalaNum(true,index,item)">
					</li>
					<!-- 金额 -->
					<li class="shopArr-itemMoney one-txt-cut ">
						￥{{item.traderGoodsMoney && item.cartNum?((item.traderGoodsMoney.toFixed(2)*100)*item.cartNum/100).toFixed(2):''}}
					</li>
					<!-- 删除按钮 -->
					<li class="shopArr-itemdelBtn showHand" @click="handleDelItemShop(false,item,index)">
						删除
					</li>
				</ul>
			</div>
			<!-- 无商品显示 -->
			<ul class="carNoShopTipsBox d-cw d-aic d-jcc" v-show="shopList && shopList.length?false:true">
				<img src="../../assets/img/privacy/noCollection.png" >
				<p>暂无商品</p>
			</ul>
			
			
			<!-- 底部提示 -->
			<div class="carBtmTipsBox d-rn d-aic d-jcb" v-show="shopList && shopList.length?true:false">
				<!-- 左侧 -->
				<ul class="carBtmTipsBox-lftBox d-rn d-aic d-jcs noSelectBox ">
					<li class="d-rn d-aic d-jcs showHand" :style="{color:allSelectState?'#e62129':'#000000'}"
					@click="handleSelectAllShop">
						<img src="../../assets/img/comm/icon_selAll.png" v-show="allSelectState" >
						<p v-show="!allSelectState"></p>
						全选
					</li>
					<li class="showHand" @click="handleDelItemShop(true)">
						删除
					</li>
				</ul>
				
				<!-- 右侧 -->
				<ul class="carBtmTipsBox-rgtBox d-rn d-aic d-jce">
					<p>已选商品<span>{{selShopArr.length}}</span>件</p>
					<p>合计（不含运费）：</p>
					<p>{{allSelShopPrice}}</p>
					<p class="showHand" @click="handleJoinSubmit">结算</p>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getAppCCartByUser,//我的购物车
		delAppCCartByUser,//商品删除
		subAndAddAppCCartByUser,//商品数量+-
		upAppCCart,		//商品规格修改
		addAppCFile,	//规格附件新增
		upAppCFile,		//规格附件修改
	} from '@/api/shopCar.js'
	import {
		addAppCCollect,//收藏接口
		delAppCCollect,//批量取消收藏
		appCTraderGoodsFindById,//商品详情接口
		selectAttrTwoBygoodsId,//二级规格列表
		newappCCommentsList,//评论接口请求
		addAppCCart,	//加入购物车
	 } from '@/api/shopDetail.js'
	import { fileUpload,appCUserFindById,appCSetupList } from '@/api/comm.js'
	
	
	import selAddress from '../../components/selAddress.vue'
	import buyJd from '../../components/buyJd'
	let _self;
	export default {
		name:"ShopCar",
		data() {
			return {
				// 用户信息
				userInfo:null,
				// 全选状态
				allSelectState:false,
				// 选择的商品列表
				selShopArr:[],
				
				//上传图片接口路径
				requestUrl:this.$store.getters.upImgUrl,
				// 文件上传
				upFileArr: [
					[
						{
							upInfo: null
						},
						{
							upInfo: null
						}
					],
					[
						{
							upInfo: null
						},
						{
							upInfo: null
						}
					],
					[
						{
							upInfo: null
						},
						{
							upInfo: null
						}
					]
				],
				
				
				// 商品列表
				shopList:null,
				// 选择的优惠券下标
				selCouponCurrent:null,
				// 编辑状态===商品下标
				selShopNum:null,
				// 规格编辑框==下标相等显示
				selEditIndex:null,
				// 选择要进行编辑的商品信息
				selEditShopInfo:null,
				// 修改框下的一级规格
				selEditShopOneGg:null,
				// 修改框下的二级规格
				selEditShopTwoGg:null,
				// 一级规格名称
				editOneGgName:null,
				// 二级规格名称
				editTwoGgName:null,
				// 选择的规格下标
				selArrGgInfo:[0,0],
				
				// 选择的商品价格
				allSelShopPrice:'0.00',
				// 点击事件请求状态
				loginState:false,
				
				// 客服提醒
				goodsExplain:'',
				
				// 定义要上传的文件下标===【第几组，第几张】
				upImgIndexArr:null,
				jmsId:this.$store.getters.getJmsId,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 显示头底部导航栏
			this.$EventBus.$emit('AppCloseNav', true);
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			if(_self.userInfo){
				// 有用户信息
				_self.handleUpdateUserInfo();
			}
			
			// 获取客服提醒
			appCSetupList().then(res=>{
				_self.goodsExplain = res.data.goodsExplain
			})
			
			// 获取购物车
			_self.handleGetAllShop();
		},
		// 方法集
		methods: {
			// 更新用户信息
			handleUpdateUserInfo(){
				appCUserFindById({
					userId:_self.userInfo.userId
				}).then(tes=>{
					if(tes.code==200){
						// 接口获取成功
						//定义本地存储的userInfo
						localStorage.setItem('userInfo',JSON.stringify(tes.data))
						// 传递给topBar==用户信息
						_self.$EventBus.$emit('userEditInfo',tes.data)
						// 定义当前用户信息
						_self.$set(_self,'userInfo',tes.data)
					}
				})
			},
			// 获取购物车列表
			handleGetAllShop(){
				getAppCCartByUser({
					catrUserId:_self.userInfo.userId
				}).then(res=>{
					// console.log('购物车列表===',res);
					// 接口成功处理
					if(res.code==200){
						/* 
							parentModularName一级类名
							parentTitle一级值
							goodAttrModularName二级类名
							goodsAttrTitle二级值
						 */
						
						// 规格处理
						res.data.forEach((it,ix)=>{
							// 定义一二级规格
							it.newGgList=[
								// 一级规格
								{
									name:it.parentModularName,
									val:it.parentTitle
								},
								// 二级规格
								{
									name:it.goodAttrModularName,
									val:it.goodsAttrTitle
								}
							]
						});
						
						// 定义购物车列表
						_self.$set(_self,'shopList',res.data)
						// _self.shopList=res.data;
					}
				})
			},
			// 跳转订单提交页面
			handleJoinSubmit(){
				if(_self.selShopArr && !_self.selShopArr.length){
					_self.$jgTips('请先选择要结算的商品')
					return false;
				}
				// console.log('选择数组====',_self.selShopArr);
				// 定义下一页面需要的商品ID
				let ids=[];
				_self.shopList.forEach((it,ix)=>{
					if(_self.selShopArr.indexOf(ix)>=0){
						// 选中了此商品
						ids.push(it.cartId)
					}
				})
				// 定义商品id
				// 编码encodeURIComponent() ||  解码decodeURIComponent()
				let pageVal=encodeURIComponent(JSON.stringify({ids}));
				// 跳转到搜索页面并传递搜索信息
				_self.$router.push({path:'/SubmitOrder',query:{id:pageVal}});
			},
			
			// 商品数量加减事件
			handleCalaNum(type,index,item){
				/* 
					type===true加，false减
					index===选中的商品下标
				 */
				
				// 防止频繁请求
				if(_self.loginState){
					_self.$jgTips('正在请求中，请稍等！');
					return false;
				}
				_self.loginState=true;
				
				// 转义变量
				let newData=JSON.parse(JSON.stringify(_self.shopList[index]));
				if(type){
					// 加
					
					// 数量加一
					newData.cartNum=newData.cartNum-0+1;
					
					// 判断规格库存上限
					if(newData.cartNum>newData.goodsAttrInventory){
						_self.$jgTips('您所选择的商品数量超过库存！')
						_self.loginState=false;
						return false;
					}
				}else{
					if(newData.cartNum==1){
						_self.loginState=false;
						return false;
					};
					
					// 减
					newData.cartNum=newData.cartNum-0-1;
				}
				// 接口请求
				subAndAddAppCCartByUser({
					cartId:item.cartId,
					cartNum:newData.cartNum
				}).then(res=>{
					if(res.code==200){
						// 赋值显示
						_self.$set(_self.shopList,index,newData);
						// 计算商品总价格
						if(_self.selShopArr && _self.selShopArr.length){
							_self.handleJsAllPrice(_self.selShopArr);
						}
					}
					// 允许再次请求
					_self.loginState=false;
				})
			},
			// 全选事件
			handleSelectAllShop(){
				if(_self.shopList && !_self.shopList.length || !_self.shopList)return;
				// 定义全选状态
				_self.allSelectState=!_self.allSelectState;
				
				// 判断
				if(_self.allSelectState){
					// 全选状态
					let newArr=[];
					_self.shopList.forEach((item,index)=>{
						newArr.push(index);
					})
					_self.selShopArr=newArr;
				}else{
					// 取消全选
					_self.selShopArr=[];
				}
			},
			// 单选事件
			handleSelItemShop(val){
				// 获取当前选择的商品数组
				let newArr =JSON.parse(JSON.stringify(_self.selShopArr));
				
				// 判断选中是否包含当前商品
				if(_self.selShopArr.indexOf(val)>=0){
					// 包含
					
					// 删除当前元素
					newArr.splice(_self.selShopArr.indexOf(val),1);
				}else{
					// 不包含
					newArr.push(val)
				}
				// 定义当前选择商品数组
				_self.$set(_self,'selShopArr',newArr);
				
				// 判断全选状态===判断选择数组长度是否相等
				_self.allSelectState=newArr.length==_self.shopList.length?true:false;
			},
			// 计算总价格
			handleJsAllPrice(val){
				// 全选的数组为空===即取消全选
				if(val && !val.length){
					// 定义商品价格
					_self.allSelShopPrice='0.00';
					return false;
				}
				
				// 定义当前价格
				let newPrice=0;
				// 深层转移商品部数组
				let newShopData=JSON.parse(JSON.stringify(_self.shopList));
				// 商品循环
				newShopData.forEach((it,ix)=>{
					val.forEach((itt,ixx)=>{
						// 下标相同===选中了当前商品
						if(ix==itt){
							
							// 计算当前价格
							newPrice=newPrice+it.traderGoodsMoney*it.cartNum*100;
						}
					})
				})
				_self.allSelShopPrice=(newPrice/100).toFixed(2);
			},
			
			
			// 图片上传===不用
			handleUploadImg(e, ix, ixx) {
				// 接收图片
				var file = e.target.files;
				var reader = new FileReader(); //读取文件
				reader.readAsDataURL(file[0]);
			
				reader.onload = function() {
					// 定义图片显示
					_self.upFileArr[ix][ixx].upInfo = reader.result;
			
				}
			},
			// 删除当前商品
			handleDelItemShop(type,it,ix){
				/* 
					type===true删除选择的商品，false删除当前选中的商品
					it===当前的商品信息==》基于type为fasle
					ix===当前的商品下标==》基于type为fasle
				 */
				// 定义接口参数
				let ids='';
				// 深层转义===购物车列表
				let shopCarList=JSON.parse(JSON.stringify(_self.shopList));
				// 定义====删除成功后应该显示的数组
				let newShopCarArr=[];
				
				
				if(type==true){
					// 多选删除
					
					// 判断选择数组是否有数据
					if(_self.selShopArr&& !_self.selShopArr.length){
						// 未选择==提示错误，阻止运行
						
						_self.$eror('请选择要删除的商品！');
						return false;
					}else if(_self.selShopArr&& _self.selShopArr.length==1){
						// 单个删除
						
						// 定义删除商品ID
						ids=shopCarList[_self.selShopArr[0]].cartId;
						// 数组中删除当前商品
						shopCarList.splice(_self.selShopArr[0],1)
						// 定义新数组
						newShopCarArr=shopCarList;
						
					}else {
						// 多个删除
						
						// 循环商品数组
						shopCarList.forEach((item,index)=>{
							if(_self.selShopArr.indexOf(index)>=0){
								// 删除当前商品
								
								// 定义删除的商品ID
								ids=ids?ids+','+item.cartId:item.cartId;
							}else{
								// 不删除当前商品
								newShopCarArr.push(item);
							}
						})
					}
				}else if(type==false){
					// 删除单个
					
					
					// 添加删除的id
					ids=it.cartId;
					
					// 删除一个商品
					shopCarList.splice(ix,1)
					// 定义商品删除成功后的购物车列表
					newShopCarArr=shopCarList;
				}
				
				// 防止接口频繁请求
				if(_self.loginState){
					_self.$jgTips('正在请求中，请稍等！')
					return false;
				}
				_self.loginState=true;
				// 接口请求
				delAppCCartByUser({ids}).then(res=>{
					if(res.code==200){
						// 提示成功
						_self.$message({
							message:res.data,
							type:'success'
						});
						// 定义显示数组
						_self.$set(_self,'shopList',newShopCarArr)
						
						// 清除全选状态
						_self.$set(_self,'allSelectState',false)
						// 定义新的选择数组
						_self.$set(_self,'selShopArr',[])
						// 计算总价格
						_self.handleJsAllPrice([])
					}
					// 允许再次请求
					_self.loginState=false;
				})
			},
			// 定义上传图片的下标
			handleSelImgInx(index,ixx){
				// console.log('上传===',[index,ixx]);
				
				// 定义上传图片的下标位置
				_self.upImgIndexArr=[index,ixx];
			},
			// 上传图片接口===失败
			handleUpFileError(){
				_self.$eror('上传图片失败');
			},
			// 上传图片接口===成功
			handleAvatarSuccess(res){
				// 判断当前上传的位置是否有图片====false有图片进行修改，true无图片进行新增
				_self.handleUpFileImgUpAdd(_self.shopList[_self.selEditIndex].appCFileList[_self.upImgIndexArr[0]]?false:true,res).then(res=>{
					// console.log('返回状态===>',res);
					
					
					// 深层转义数据====显示的图片数组
					let newUpImgList=JSON.parse(JSON.stringify(_self.upFileArr));
					// 深层转义数据==要修改的商品
					let newDataItem=JSON.parse(JSON.stringify(_self.shopList[_self.selEditIndex]));
					
					// 判断==修改/新增
					if(_self.shopList[_self.selEditIndex].appCFileList[_self.upImgIndexArr[0]]){
						// 修改
						
						
						if(_self.upImgIndexArr[1]==0){
							// 文件
							newDataItem.appCFileList[_self.upImgIndexArr[0]].fileFileUrl=res;
						}else{
							// 图片
							newDataItem.appCFileList[_self.upImgIndexArr[0]].fileImgUrl=res;
						}
						// 定义===上传的文件/图片
						newUpImgList[_self.upImgIndexArr[0]][_self.upImgIndexArr[1]].upInfo = res;
					}else{
						// 新增
						
						// 增加新数据
						newDataItem.appCFileList.push(res);
						
						// 定义===上传的文件/图片
						newUpImgList[_self.upImgIndexArr[0]][_self.upImgIndexArr[1]].upInfo = _self.upImgIndexArr[1]==0?res.fileFileUrl:res.fileImgUrl;
					}
					
					
					// 强制定义===商品信息
					_self.$set(_self.shopList,_self.selEditIndex,newDataItem);
					// 上传图片成功回调===定义上传图片的信息
					_self.$set(_self,'upFileArr',newUpImgList);
					// 提示成功
					_self.$message({
						message:'图片上传成功',
						type:'success'
					});
				})
			},
			// 文件新增和修改
			handleUpFileImgUpAdd(state,file=''){
				return new Promise((resolve,reject)=>{
					if(state==true){
						// 文件新增
						
						// 新增接口
						addAppCFile({
							cartId:_self.shopList[_self.selEditIndex].cartId,
							fileFileUrl:_self.upImgIndexArr[1]==0?file:'',
							fileImgUrl:_self.upImgIndexArr[1]==1?file:'',
						}).then(res=>{
							// console.log('新增接口请求成功====',res);
							
							if(res.code==200){
								return resolve(res.data);
							}
						})
						// console.log('文件新增====当前编辑的商品下标',_self.selEditIndex);
						// console.log('文件新增====当前编辑的商品信息',_self.shopList[_self.selEditIndex]);
					}else{
						// 文件修改
						
						// 修改接口
						upAppCFile({
							fileId:_self.shopList[_self.selEditIndex].appCFileList[_self.upImgIndexArr[0]].fileId,
							fileFileUrl:_self.upImgIndexArr[1]==0?file:_self.shopList[_self.selEditIndex].appCFileList[_self.upImgIndexArr[0]].fileFileUrl,
							fileImgUrl:_self.upImgIndexArr[1]==1?file:_self.shopList[_self.selEditIndex].appCFileList[_self.upImgIndexArr[0]].fileImgUrl,
						}).then(res=>{
							// console.log('修改成功===',res);
							if(res.code==200){
								return resolve(true)
							}
						})
					}
				})
			},
			
			
			
			
			
			// 确认修改规格
			handleAgainShopGg(item,index){
				// console.log('查看修改信息====',[item,index]);
				// console.log('选择的二级规格信息===',_self.selEditShopTwoGg[_self.selArrGgInfo[1]]);
				
				
				// 防止频繁请求
				if(_self.loginState)return ;
				// 点击事件触发状态===
				_self.loginState=true;
				
				// 修改规格接口upAppCCart
				upAppCCart({
					cartId:item.cartId,
					cartNum:item.cartNum,
					catrUserId:_self.userInfo.userId,
					goodsAttrId:_self.selEditShopTwoGg[_self.selArrGgInfo[1]].goodsAttrId,
					traderGoodsId:_self.selEditShopTwoGg[_self.selArrGgInfo[1]].tarderGoodsId
				}).then(res=>{
					// console.log('修改规格成功===',res);
					if(res.code==200){
						// 修改成功
						_self.$message({
							message:'修改成功！',
							type:'success'
						})
						
						// 关闭修改弹窗
						_self.selEditIndex=null;
						
						// 查询列表
						_self.handleGetAllShop();
					}
				}).finally(err=>{
					_self.loginState=false;
				})
			},
			// 显示编辑框
			handleSelEditState(item,index){
				// console.log('查看要编辑的规格信息====',item);
				
				
				// 清空图片列表
				let imgArrList=[
					[
						{
							upInfo: null
						},
						{
							upInfo: null
						}
					],
					[
						{
							upInfo: null
						},
						{
							upInfo: null
						}
					],
					[
						{
							upInfo: null
						},
						{
							upInfo: null
						}
					]
				];
				_self.$set(_self,'upFileArr',imgArrList)
				
				
				
				// 查询商品详情接口
				// 防止频繁请求
				if(_self.loginState)return;
				_self.loginState=true;
				
				// 搜索修改的商品详情
				appCTraderGoodsFindById({
					tarderGoodsId:item.traderGoodsId,
					userId:_self.userInfo.userId
				}).then(res=>{
					// console.log('要修改的信息====》',res);
					if(res.code==200 && res.data){
						// 定义要编辑的商品信息
						_self.selEditShopInfo=res.data;
						// 定义商品一级规格
						_self.selEditShopOneGg=res.data.goodsIdOneList;
						// 定义商品二级规格
						_self.selEditShopTwoGg=res.data.goodsIdTwoList;
						// 定义规格名称===自上向下一二
						_self.editOneGgName=res.data.goodsIdOneList && res.data.goodsIdOneList.length?res.data.goodsIdOneList[0].goodAttrModularName:'';
						_self.editTwoGgName=res.data.goodsIdTwoList && res.data.goodsIdTwoList.length?res.data.goodsIdTwoList[0].goodAttrModularName:'';
						
						// 定义文件上传信息upFileArr
						if(item.appCFileList &&item.appCFileList.length){
							item.appCFileList.forEach((iit,ixx)=>{
								// 文件
								if(iit.fileFileUrl){
									_self.upFileArr[ixx][0].upInfo=iit.fileFileUrl;
								}
								// 图片
								if(iit.fileImgUrl){
									_self.upFileArr[ixx][1].upInfo=iit.fileImgUrl;
								}
								// console.log('查看itt=====',_self.upFileArr);
							})
						}
						
						
						// 判断一级规格的高亮下标
						if(res.data.goodsIdOneList.length>1){
							// 循环一级规格
							res.data.goodsIdOneList.forEach((itt,ixx)=>{
								// 判断===确定一级规格的下标
								if(itt.goodsAttrTitle==item.parentTitle){
									// 找到了
									
									// 定义高亮的下标
									_self.selArrGgInfo[0]=ixx;
									
									// 判断下标大于0时，查询二级规格
									if(ixx>0){
										
										// 允许接口请求
										_self.loginState=false;
										// 定义修改框===显示修改框
										_self.selEditIndex=index;
										// 搜索二级规格
										_self.handleSelEditShopGg(true,ixx,item);
									}else{
										// 下标为0===直接在二级规格中查询
										res.data.goodsIdTwoList.forEach((iiti,iixi)=>{
											if(iiti.goodsAttrTitle==item.goodsAttrTitle){
												// 找到了
												
												// 定义当前规格高亮下标
												_self.$set(_self.selArrGgInfo,1,iixi)
											}
										})
									}
								}
							})
						}else{
							// 定义高亮的下标为0
							_self.selArrGgInfo[0]=0
						}
						
						
						// 允许再次请求
						_self.loginState=false;
						// 定义修改框===显示修改框
						_self.selEditIndex=index;
					}
					// 允许再次请求
					_self.loginState=false;
				})
			},
			// 选择一二级规格
			handleSelEditShopGg(typeInx,index,selShopInfo){
				/* 
					typeInx===true一级规格false二级规格
					index===选择的商品下标
					selShopInfo===选中的购物车商品信息
				 */
				// 防止频繁请求
				if(_self.loginState)return ;
				// 点击事件触发状态===
				_self.loginState=true;
				
				// 判断选择规格级别===typeInx
				if(typeInx){
					// 一级规格
					// 查询二级规格
					selectAttrTwoBygoodsId({
						attroneid:_self.selEditShopOneGg[index].goodsAttrId,
						goodsId:_self.shopList[_self.selEditIndex].goodsId,
						traderId: _self.jmsId,
					}).then(res=>{
						if(res.code==200){
							
							// 定义二级规格
							// 定义一级规格==高亮显示
							_self.$set(_self.selArrGgInfo,0,index)
							// 定义二级规格显示数组
							_self.$set(_self,'selEditShopTwoGg',res.data);
							
							// 判断是否有selShopInfo
							if(selShopInfo){
								// 查询搜索二级规格高亮的下标
								
								// 查询二级规格
								res.data.forEach((iti,ixi)=>{
									if(iti.goodsAttrTitle==selShopInfo.goodsAttrTitle){
										// 找到了
										
										// 定义当前规格高亮下标
										_self.$set(_self.selArrGgInfo,1,ixi)
									}
								})
							}
						}
						// 允许再次请求
						_self.loginState=false;
					})
					
				}else{
					// 二级规格
					// 定义二级规格==高亮显示
					_self.$set(_self.selArrGgInfo,1,index);
					// 允许再次请求
					_self.loginState=false;
				}
			},
			// 鼠标进入商品规格
			handleCarJoinItemShop(val){
				// 定义显示编辑规格的商品下标
				_self.selShopNum=val;
			},
			// 鼠标离开商品规格
			handleGoOutBox(){
				// 关闭规格高亮
				_self.selShopNum=null;
				
				// 修改规格打开的情况下===关闭
				return false;
				if (_self.selEditIndex>=0) {
					_self.selEditIndex = null
				}
			},
			
			
			// 选择优惠券
			handleSelCoupon(val){
				// 定义选择的下标
				_self.selCouponCurrent=val;
				
				// 计算总价格
			},
		},
		// 组件集
		components:{
			buyJd,
			selAddress
		},
		mounted() {
			// 滚动到头部
			window.scrollTo({
				left: 0,
				top: 0,
			});
			
			// 定义背景颜色
			document.body.style.background='#FFFFFF';
			
			// 监听点击事件===编辑框显示状态下点击其他区域关闭
			// document.addEventListener('click', () => {
			// 	if (_self.selEditIndex>=0) {
			// 		_self.selEditIndex = null
			// 	}
			// })
		},
		watch:{
			selShopArr(nval){
				// 计算总价格
				_self.handleJsAllPrice(nval);
			}
		},
		computed:{
		
		},
		// 过滤器
		filters:{
			
		},
		// 实例销毁
		destroyed(){
			
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>
<style lang="scss">
	/* 中心区域 */
	.carCont{
		width: 1200px;
		min-height: 600px;
		margin: 0 auto;
	}
	/* 商品列表标题 */
	.carTit{
		width: 100%;
		border-bottom: 4px solid #e1e1e1;
		position: relative;
		/* 左 */
		&-lftBox{
			position: absolute;
			bottom: -4px;
			left: 0;
			z-index: 10;
			width: 180px;
			margin-right: 10px;
			p:nth-of-type(1){
				font-size: 24px;
				font-weight: 700;
				text-align: left;
				color: #e62129;
				letter-spacing: 3px;
			}
			p:nth-of-type(2){
				width: 100%;
				height: 4px;
				background: #e62129;
				margin-top: 15px;
			}
		}
		/* 右 */
		&-rgtBox{
			flex: 1;
			padding-bottom: 15px;
			overflow: hidden;
			p:nth-of-type(1){
				font-size: 20px;
				font-weight: 400;
				text-align: right;
				color: #333333;
				letter-spacing: 2px;
			}
			p:nth-of-type(2){
				margin: 0 10px;
				font-size: 20px;
				font-weight: 700;
				text-align: right;
				color: #e62129;
				letter-spacing: 2px;
			}
			p:nth-of-type(3){
				width: 64px;
				height: 32px;
				opacity: 1;
				background: #999999;
				border-radius: 2px;
				text-align: center;
				line-height: 32px;
				
				font-size: 16px;
				font-weight: 400;
				text-align: center;
				color: #ffffff;
				letter-spacing: 2px;
			}
		}
	}
	/* 次标题 */
	.conTipsBox{
		width: 100%;
		padding: 40px 48px 0 10px;
		box-sizing: border-box;
		/* 左 */
		&-lftBox{
			p:nth-of-type(1){
				img{
					width: 24px;
					height: 24px;
				}
				i{
					display: inline-block;
					width: 24px;
					height: 24px;
					opacity: 1;
					background: #ffffff;
					border: 1px solid #cccccc;
					box-sizing: border-box;
				}
				span{
					display: inline-block;
					margin-left: 12px;
					font-size: 20px;
					font-weight: 400;
					text-align: left;
					color: #333333;
					letter-spacing: 2px;
				}
			}
			p:nth-of-type(2){
				margin-left: 71px;
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				color: #333333;
				letter-spacing: 2px;
			}
		}
		/* 右 */
		&-rgtBox{
			p{
				font-size: 20px;
				font-weight: 400;
				color: #333333;
				letter-spacing: 2px;
			}
			p:nth-of-type(1){
				margin-right: 118px;
			}
			p:nth-of-type(2){
				margin-right: 94px;
			}
			p:nth-of-type(3){
				margin-right: 100px;
			}
		}
	}
	
	
	
	/* 购物车有数据 */
	.shopArr{
		width: 100%;
		/* 每个商品 */
		&-itemUlBox{
			width: 100%;
			padding: 0px 0 20px;
			box-sizing: border-box;
			opacity: 1;
			border: 1px solid #cccccc;
			margin-top: 20px;
		}
		/* 每个商品==选中样式 */
		&-itemSelBox{
			padding: 20px 15px 0 10px;
			// padding: 0px 15px 0 10px;
			box-sizing: border-box;
			p{
				width: 24px;
				height: 24px;
				img{
					width: 100%;
					height: 100%;
				}
			}
		}
		/* 商品图片 */
		&-itemImg{
			padding-top: 20px;
			box-sizing: border-box;
			
			width: 100px;
			height: 100px;
			img{
				width: 100%;
				height: 100%;
			}
		}
		/* 商品名称 */
		&-itemName{
			padding-top: 20px;
			box-sizing: border-box;
			margin-left: 10px;
			width: 245px;
			font-size: 18px;
			font-weight: 400;
			text-align: left;
			color: #333333;
			letter-spacing: 2px;
			margin-right: 20px;
		}
		/* 规格 */
		&-itemSpecs{
			padding:10px 0 0 30px;
			width: 218px;
			height: 120px;
			position: relative;
			box-sizing: border-box;
			border: 1px solid #fff;
			/* 规格外层盒子 */
			&-listBox{
				flex: 1;
				height: 100%;
				overflow-y: scroll;
				overflow-x: hidden;
			}
			&-listBox::-webkit-scrollbar{
				width: 0px;
				background: none;
			}
			/* 规格 */
			&-ittTxt{
				flex: 1;
				box-sizing: border-box;
				
				font-size: 18px;
				font-weight: 400;
				text-align: left;
				color: #999999;
				letter-spacing: 2px;
			}
			
			
			/* 修改按钮 */
			&-editBtn{
				position: absolute;
				top: 0;
				right: 0;
				width: 46px;
				height: 20px;
				opacity: 1;
				background: #e62129;
				text-align: center;
				line-height: 20px;
				
				font-size: 14px;
				font-weight: 400;
				color: #ffffff;
				letter-spacing: 1px;
			}
			/* 编辑弹框 */
			&-editBox{
				position: absolute;
				top: 89px;
				left: -1px;
				background: yellow;
				z-index: 6;
				padding-top: 20px;
				/* 投个三角形 */
				&-sanYi{
					width: 0;
					height: 0;
					border-left: 25px solid transparent;
					border-right: 25px solid transparent;
					// border-bottom: 40px solid yellow;
					border-bottom: 40px solid #ccc;
					position: absolute;
					top: 0;
					left: 40px;
					z-index: 0;
				}
				&-sanEr{
					width: 0;
					height: 0;
					border-left: 20px solid transparent;
					border-right: 20px solid transparent;
					// border-bottom: 35px solid red;
					border-bottom: 35px solid #fff;
					position: absolute;
					top: 5px;
					left: 45px;
					z-index: 0;
				}
				&-sanSab{
					width: 0;
					height: 0;
					border-left: 15px solid transparent;
					border-right: 15px solid transparent;
					border-bottom: 25px solid #fff;
					position: absolute;
					top: 3px;
					left: 50px;
					z-index: 4;
				}
				
				/* 白色边框 */
				&-selGgBox{
					position: absolute;
					top: 20px;
					left: 0;
					z-index: 3;
					width: 717px;
					padding:10px 30px 22px;
					box-sizing: border-box;
					opacity: 1;
					background: #ffffff;
					border: 1px solid #cccccc;
				}
				/* 每个规格 */
				&-itemLiBox{
					width: 100%;
					margin-top: 10px;
				}
				/* 左侧=分类名称 */
				&-itemlftBox{
					width: 107px;
					font-size: 20px;
					font-weight: 400;
					text-align: left;
					color: #999999;
					letter-spacing: 2px;
					margin-top: 10px;
				}
				/* 右侧=规格列表 */
				&-itemRgtBox{
					flex: 1;
					span{
						display: inline-block;
						padding: 6px 14px;
						box-sizing: border-box;
						font-size: 18px;
						font-weight: 400;
						
						margin-right: 10px;
						margin-top: 10px;
					}
					
					
					
				}
				
				/* 上传照片文件 */
				&-itemUpImg{
					flex: 1;
				}
				&-itemImgBox{
					i{
						display: inline-block;
						width: 80px;
						height: 80px;
						position: relative;
						img{
							width: 100%;
							height: 100%;
						}
						input{
							position: absolute;
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
							opacity: 0;
							background: red;
						}
					}
					i:nth-of-type(1){
						margin-right: 10px;
					}
				}
				
				/* 提示 */
				&-itemTipsBox{
					width: 100%;
					padding-left: 107px;
					box-sizing: border-box;
					margin-top: 10px;
					font-size: 20px;
					font-weight: 400;
					text-align: left;
					color: #e62129;
					letter-spacing: 2px;
				}
				/* 确认按钮 */
				&-itemBtnBox{
					width: 100%;
					padding-left: 107px;
					box-sizing: border-box;
					margin-top: 30px;
					// 确认
					p:nth-of-type(1){
						width: 72px;
						height: 30px;
						opacity: 1;
						background: #e62129;
						text-align: center;
						line-height: 30px;
						
						font-size: 14px;
						font-weight: 400;
						color: #ffffff;
						letter-spacing: 1px;
						margin-right: 30px;
					}
					// 取消
					p:nth-of-type(2){
						font-size: 14px;
						font-weight: 400;
						color: #3239ff;
						letter-spacing: 1px;
					}
				}
			}
		}
		.selGGCla{
			background: #e62129;
			border-radius: 2px;
			color: #ffffff;
		}
		.noselGGCla{
			border: 1px solid #cccccc;
			border-radius: 2px;
			color: #333333;
		}
		/* 价格 */
		&-itemPrice{
			padding-top: 20px;
			box-sizing: border-box;
			margin-left: 20px;
			width: 160px;
			
			font-size: 18px;
			font-weight: 400;
			color: #333333;
			letter-spacing: 2px;
		}
		/* 数量 */
		&-itemNumber{
			padding-top: 20px;
			box-sizing: border-box;
			img{
				width: 18px;
				height: 18px;
			}
			p{
				width: 40px;
				padding: 0 5px;
				box-sizing: border-box;
				
				font-size: 16px;
				font-weight: 400;
				text-align: center;
				color: #333333;
			}
		}
		/* 金额 */
		&-itemMoney{
			padding-top: 20px;
			box-sizing: border-box;
			margin-left: 60px;
			width: 150px;
			
			font-size: 18px;
			font-weight: 700;
			text-align: left;
			color: #e62129;
			letter-spacing: 2px;
		}
		/* 删除 */
		&-itemdelBtn{
			padding-top: 20px;
			box-sizing: border-box;
			font-size: 18px;
			font-weight: 400;
			text-align: left;
			color: #999999;
			letter-spacing: 2px;
		}
		
		
	}
	.marboxTop10{
		margin-top: 10px;
	}
	.borXf{
		border: 1px dashed #e62129;
		box-sizing: border-box;
	}
	/* 购物车无数据 */
	.carNoShopTipsBox{
		padding: 81px 0 125px ;
		box-sizing: border-box;
		width: 100%;
		img{
			width: 352px;
			height: 352px;
			margin-bottom: 15px;
		}
		p{
			font-size: 18px;
			font-weight: 400;
			text-align: center;
			color: #666666;
			letter-spacing: 1px;
		}
	}
	
	
	
	
	
	
	
	/* 底部提示 */
	.carBtmTipsBox{
		width: 100%;
		margin: 100px 0 20px;
		height: 56px;
		opacity: 1;
		background: #f5f5f5;
		/* 左侧 */
		&-lftBox{
			padding-left: 10px;
			box-sizing: border-box;
			margin-right: 10px;
			li:nth-of-type(1){
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				letter-spacing: 2px;
				p{
					display: inline-block;
					width: 24px;
					height: 24px;
					opacity: 1;
					background: #ffffff;
					border: 1px solid #cccccc;
					box-sizing: border-box;
					margin-right: 12px;
				}
				img{
					width: 24px;
					height: 24px;
					margin-right: 12px;
				}
			}
			li:nth-of-type(2){
				margin-left: 80px;
				font-size: 20px;
				font-weight: 400;
				text-align: left;
				color: #000000;
				letter-spacing: 2px;
			}
		}
		/* 右侧 */
		&-rgtBox{
			flex: 1;
			overflow: hidden;
			p:nth-of-type(1){
				margin-right: 50px;
				font-size: 20px;
				font-weight: 400;
				color: #333333;
				letter-spacing: 2px;
				span{
					font-size: 24px;
					color:#E62129;
				}
			}
			p:nth-of-type(2){
				font-size: 20px;
				font-weight: 400;
				text-align: right;
				color: #333333;
				letter-spacing: 2px;
			}
			p:nth-of-type(3){
				font-size: 24px;
				font-weight: 700;
				text-align: right;
				color: #e62129;
				letter-spacing: 3px;
			}
			p:nth-of-type(4){
				width: 112px;
				height: 56px;
				opacity: 1;
				background: #999999;
				text-align: center;
				line-height: 56px;
				margin-left: 20px;
				font-size: 20px;
				font-weight: 700;
				color: #ffffff;
				letter-spacing: 5px;
			}
		}
	}
</style>